import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import CommonModal from "../Common/CommonModal";
import { OpenFirstModal, ToggleBetweenModal } from "../../../../Constant";
import { TOGGLE_MODAL_LIST } from "../../../../Data/UiKit/Modal";
import { useState } from "react";
import { Btn } from "../../../../AbstractElements";
import { ToggleParentModal } from "./ToggleParentModal";

const ToggleBetweenModals = () => {
  const [modal, setModal] = useState(false);
  const [nestedModal, setNestedModal] = useState(false);
  const [closeAll, setCloseAll] = useState(false);

  const toggle = () => setModal(!modal);

  const toggleNested = () => {
    setNestedModal(!nestedModal);
    setCloseAll(false);
  };

  const toggleAll = () => {
    setNestedModal(!nestedModal);
    setCloseAll(true);
  };
  return (
    <Col xl="4">
      <Card>
        <CommonCardHeader title={ToggleBetweenModal} span={TOGGLE_MODAL_LIST} />
        <CardBody className="badge-spacing">
          <Btn color="dark" onClick={toggle}>{OpenFirstModal}</Btn>
          <CommonModal centered fade={true} isOpen={modal} toggle={toggle}>
            <ToggleParentModal nestedModal={nestedModal} closeAll={closeAll} toggle={toggle} toggleNested={toggleNested} toggleAll={toggleAll}/>
          </CommonModal>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ToggleBetweenModals;